export const MODIFY_FILE_PK = 'MODIFY_FILE_PK';

export function modifyFilePK(filePK){
    return{
        type: MODIFY_FILE_PK,
        mainState: {
            filePK: filePK
        }
    }
}